import { LogLevel, OneSignal } from 'react-native-onesignal';
import { ONE_SIGNAL_API, getChannel } from '../../config/config';
import { isWeb } from '../../config/designSystem/Layout';

export const oneSignalInit : () => Promise<void> = async () =>  {
  if(!isWeb) {
    const channel = getChannel();
    let loglevel= LogLevel.Warn;
    if(channel === 'demo' || channel === 'production') {
      loglevel = LogLevel.None;
    }

    OneSignal.Debug.setAlertLevel(LogLevel.None);
    OneSignal.Debug.setLogLevel(loglevel);
    OneSignal.setConsentRequired(true);
    OneSignal.setConsentGiven(true);
    OneSignal.initialize(ONE_SIGNAL_API);







  }

};





